export enum Locale {
  EN = 'en-US',
  HE = 'he',
}
